export default __webpack_public_path__ + "static/summer-dancing-e9b6ad2df5c86323870f37d076ad679d.jpg";